import React from "react";

const PlanTabs = ({ active, setActive, plans = [] }) => {
  const tabs = plans.length ? plans : [20, 50, 100];

  return (
    <div className="flex items-center gap-2 rounded-xl bg-gray-200 p-1">
      {tabs.map((p) => {
        const label = p >= 100 ? "100+" : `${p}+`;

        return (
          <button
            key={p}
            onClick={() => setActive(p)}
            className={`cursor-pointer rounded-lg px-4 py-1 text-lg transition ${
              active === p ? "text-primary bg-white shadow" : "text-gray-500"
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default PlanTabs;
